import * as React from "react";
import * as _ from "lodash";
import * as moment from "moment";
import { IOpoSemesterPayable } from "@nkr/store/billing/actions-admin-opo-payable";
import { FormControl } from 'react-bootstrap';
import { FormEvent } from 'react';

type RowProps = {
    rank: number,
    data: IOpoSemesterPayable,
    onUpdatePayable: (payable: IOpoSemesterPayable) => void
}

interface IState extends IOpoSemesterPayable {

}

const formatMoney = (value: any) => {
    let num = Number(value);
    return isNaN(num) ? "$-.--" : `\$${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

const formatDate = (value: any, format = "MM/DD/YYYY", defaultValue = "--") => {
    let date = moment(value);
    return date.isValid() ? date.format(format) : "--"
}

class OpoPayableRow extends React.Component<RowProps, IState> {
    readonly state: IState = {
        opoId: 0,
        opoAlias: "",
        opoHasAchOnFile: false,
        transplantYear: 0,
        transplantSemester: 0,
        semesterStartDateTime: "",
        semesterEndDateTime: "",
        transplantCount: 0,
        totalInvoiced: 0,
        paymentAmount: 0,
        paymentDateTime: "",
        paymentAchConfirmation: "",
        daysOutstanding: 0
    }

    componentDidMount = () => {
        this.setState({
            opoId: this.props.data.opoId,
            opoAlias: this.props.data.opoAlias,
            opoHasAchOnFile: this.props.data.opoHasAchOnFile,
            transplantYear: this.props.data.transplantYear,
            transplantSemester: this.props.data.transplantSemester,
            semesterStartDateTime: this.props.data.semesterStartDateTime,
            semesterEndDateTime: this.props.data.semesterEndDateTime,
            transplantCount: this.props.data.transplantCount,
            totalInvoiced: this.props.data.totalInvoiced,
            paymentAmount: this.props.data.paymentAmount,
            paymentDateTime: this.props.data.paymentDateTime,
            paymentAchConfirmation: this.props.data.paymentAchConfirmation,
            daysOutstanding: this.props.data.daysOutstanding
        });
    }

    handlePaymentDateChange = (e: FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({ paymentDateTime: e.currentTarget.value });
    }

    handlePaymentAmountChange = (e: FormEvent<HTMLInputElement>) => {
        let paymentAmount = Number(e.currentTarget.value);

        this.setState({ paymentAmount });
    }

    handlePaymentAchChange = (e: FormEvent<HTMLInputElement>) => {
        let paymentAchConfirmation = e.currentTarget.value;
        let paymentAmount = this.state.paymentAmount;
        let paymentDateTime = this.state.paymentDateTime;

        if (paymentAmount == null) { paymentAmount = this.state.totalInvoiced; }
        if (paymentDateTime == null) { paymentDateTime = moment().format("YYYY-MM-DDT00:00:00"); }

        this.setState({
            paymentAchConfirmation,
            paymentAmount,
            paymentDateTime
        });
    }

    handleUpdatePayable = () => {
        this.props.onUpdatePayable(this.state);
    }

    render = () => {
        let item = this.state;

        return (
            <tr key={`${item.opoAlias}_${item.semesterEndDateTime}`}>
                <td>{this.props.rank}</td>
                <td>{item.opoAlias}</td>
                <td>{item.opoHasAchOnFile && <span className="label label-success">Yes</span>}</td>
                <td>{item.transplantCount}</td>
                <td>{formatDate(item.semesterEndDateTime)}</td>
                <td>{formatMoney(item.totalInvoiced)}</td>
                <td>
                    <FormControl
                        type='date'
                        value={moment(item.paymentDateTime).format("YYYY-MM-DD")}
                        onChange={this.handlePaymentDateChange}
                    />
                </td>
                <td><input className="form-control" type="number" value={item.paymentAmount} onChange={this.handlePaymentAmountChange} /></td>
                <td><input className="form-control" type="text" value={item.paymentAchConfirmation} onChange={this.handlePaymentAchChange} /></td>
                <td><button className="btn btn-primary btn-sm" type="button" onClick={this.handleUpdatePayable}>Update</button></td>
            </tr>
        )
    }
}

export default OpoPayableRow;